import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import InputField from "../../common/InputFieldWithDropDown/InputField";
import styles from "./HeroContainer.module.css";
import russiaFlag from "../../public/assets/russiaflag.svg"
import usFlag from "../../public/assets/usflag.svg"
import IndiaImg from "../../public/assets/inflag.svg"
import { getOfflineExchangeRate } from "../../api";
import { addCommasInPrice, bigDecimalOp, decimalAdjust } from "../../utils";
import { useMyContext } from "../../myContext";
import { useNavigate } from "react-router";

function OfflineCalculatorBox() {
  const [paymentMethod, setPaymentMethod] = useState("Online");
  const [amountRUB, setAmountRUB] = useState("10000");
  const [currency, setCurrency] = useState("RUB");
  const [amountExceedError, setAmountExceedError] = useState("");
  const [labelValue, setLabelValue] = useState();
  const [AmountConversion, setAmountConversion] = useState("--");
  const [totalAmount, setTotalAmount] = useState();
  const [quoteRate, setQuoteRate] = useState();
  const inputE1 = useRef(null);
  const {themeColor, loadingLogo} = useMyContext();
  const navigate = useNavigate();

  const allLabelVal = [
    {
      Head: "INR",
      Value: "--",
    },
    {
      Head: "Tax Collected at Source [TCS]",
      Value: "--",
    },
    {
      Head: "Goods and Service Tax",
      Value: "--",
    },
    {
      Head: "Transfer Fee",
      Value: "--",
    },
  ];

  const currencyDropdown = [
    {
      label: "RUB",
      value: "RUB",
      image: russiaFlag
    },
    {
      label: "USD",
      value: "USD",
      image: usFlag
    }
  ]

  useEffect(() => {
    setLabelValue(allLabelVal);
  }, [inputE1]);

  const getExchangeRate = async() => {
    let mode = paymentMethod === "Online" ? "ONLINE" : "CASH"
    const partnerShortCode = sessionStorage.getItem("partnerShortCode");
    try{
      const resp = await getOfflineExchangeRate(mode, currency, partnerShortCode);
      if(resp?.data?.quote){
        setQuoteRate(resp?.data?.quote);
      }
      
    }
    catch(e){
    }
  }

  useEffect(() => {
    getExchangeRate();
  },[currency, paymentMethod])

  useEffect(() => {
    if (amountRUB > 0 && quoteRate) { 
      const calculatedRUBtoINR = bigDecimalOp(amountRUB, quoteRate, "multiply");
      let calculatedtcs;
  
      if (calculatedRUBtoINR >= 700001) {
          calculatedtcs = bigDecimalOp(0.05, calculatedRUBtoINR, "multiply");
      } else {
        calculatedtcs = 0;
      }
  
      let taxableAmount;
      if (calculatedRUBtoINR <= 100000) {
        taxableAmount = Math.max(bigDecimalOp(0.01, calculatedRUBtoINR, "multiply"), 250);
      } else if (calculatedRUBtoINR > 100000 && calculatedRUBtoINR <= 1000000) {
        const minusval = bigDecimalOp(calculatedRUBtoINR, 100000, "subtract");
        const mulval = bigDecimalOp(0.005, minusval, "multiply");
        taxableAmount = bigDecimalOp(mulval, 1000, "add");
      } else if (calculatedRUBtoINR > 1000000) {
        const minusval = bigDecimalOp(calculatedRUBtoINR, 1000000, "subtract");
        const mulval = bigDecimalOp(0.001, minusval, "multiply");
        taxableAmount = Math.min(bigDecimalOp(mulval, 5500, "add"), 60000);
      } else {
        taxableAmount = 0;
      }
  
      const calculatedgst = bigDecimalOp(0.18, taxableAmount, "multiply");
      
      const updatedVal = labelValue.map((item) => {
        switch (item.Head) {
          case "INR":
            return { ...item, Value: addCommasInPrice(calculatedRUBtoINR.toString()) };
          case "Transfer Fee":
            return { ...item, Value: "1000" };
          case "Tax Collected at Source [TCS]":
            return { ...item, Value: addCommasInPrice(calculatedtcs.toString()) };
          case "Goods and Service Tax":
            return { ...item, Value: addCommasInPrice(calculatedgst.toString()) };
          default:
            return item;
        }
      });
  
      setLabelValue(updatedVal);
      const addINRandTCS = bigDecimalOp(calculatedRUBtoINR, calculatedtcs, "add");
      const addTCSFees = bigDecimalOp(calculatedgst, 1000, "add");
      const total = bigDecimalOp(addINRandTCS, addTCSFees, "add");
      const totalDecimalAdjust =  decimalAdjust('ceil', total, -2);
      setTotalAmount(totalDecimalAdjust);
      setAmountConversion(addCommasInPrice(totalDecimalAdjust));
    } else if (amountRUB === "") {
      const updatedVal = labelValue.map((item) => {
        switch (item.Head) {
          case "INR":
            return { ...item, Value: "--" };
          case "Transfer Fee":
            return { ...item, Value: "--" };
          case "Tax Collected at Source [TCS]":
            return { ...item, Value: "--" };
          case "Goods and Service Tax":
            return { ...item, Value: "--" };
          default:
            return item;
        }
      });
      setLabelValue(updatedVal);
      setAmountConversion("--");
    }
  }, [amountRUB, quoteRate, paymentMethod, currency]);

  const handleChange = (e) => {
    setPaymentMethod(e.target.value); 
  };

  const inputAmount = (e) => {
    const inputValue = e.target.value;
    if (
      inputValue >= 0 &&
      inputValue.indexOf(".") === -1 &&
      inputValue.length <= 7
    ) {
      setAmountRUB(inputValue);
    }
  };

  return (
    <div className={styles.calculatorBox}>
      <Row style={{ marginBottom: "10px" }}>
        <Col
          md={6}
          sm={4}
          xs={6}
          className={styles.transferMoneyHeading}
          style={{ padding: "0px", marginBottom: "10px" }}
        >
          Payment Method{" "}
        </Col>
        <Col md={3} sm={4} xs={3}>
          <Form.Check
            type="radio"
            label="Online"
            name="paymentMethod"
            id="paymentMethodOnline"
            value="Online"
            checked={paymentMethod === "Online"}
            onChange={handleChange}
            className={styles.transferMoneyHeading}
            style={{ marginBottom: "10px" }}
          />
        </Col>
        <Col md={3} sm={4} xs={3}  style={{paddingRight: "0px"}}>
          <Form.Check
            type="radio"
            label="Cash"
            name="paymentMethod"
            id="paymentMethodCash"
            value="Cash"
            checked={paymentMethod === "Cash"}
            onChange={handleChange}
            className={styles.transferMoneyHeading}
            style={{ marginBottom: "10px"}}
          />
        </Col>
      </Row>
      <Row>
        <InputField
          label={"Recipient gets"}
          conversionValueButton={currency}
          value={amountRUB}
          onChange={(e) => {
            inputAmount(e);
          }}
          errorMessage={amountExceedError}
          forwardedRef={inputE1}
          image={russiaFlag}
          dropdown={true}
          dropdownType={"QuoteScreen"}
          setCurrency={setCurrency}
          currencyOption={currencyDropdown}
        />
      </Row>
      {/* <ConversionRow data={labelValue} />; */}
      {labelValue &&
        labelValue.map((data, index) => {
          return (
            <Row key={index} className={styles.inputConversionRow}>
              <Col
                className={styles.inputBoxHeading}
                lg={8}
                md={7}
                sm={7}
                xs={7}
              >
                {data.Head}
              </Col>
              <Col className={styles.inputBoxValue} lg={4} md={5} sm={5} xs={5}>
                {data.Value}
              </Col>
            </Row>
          );
        })}
      <Row className="pt-3">
        <InputField
          label={"You pay"}
          conversionValueButton={"INR"}
          disabled={true}
          value={AmountConversion}
          inputSize="quote"
          image={IndiaImg}
        />
      </Row>
      <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
            {loadingLogo ? <Button
            onClick={() => {
              navigate("/login")
            }}
              className={styles.proceedButton}
              style={{background: themeColor, border: "0px"}}
            >
              Get Started
            </Button> : ""}
            </div>
    </div>
  );
}

export default OfflineCalculatorBox;
